import keymirror from 'keymirror'

export const UNIFIED_PIPELINE_FILE_UPLOADER_STATUS = keymirror({
  completed: null,
  failure: null,
})
